import React, { useState, useEffect } from 'react'
import pathname from '../../constants/pathname'
import ProjectDataTable from '../dataTable/ProjectDataTable'
import { useHistory } from 'react-router-dom'
import { getScrutinize } from '../../redux/actions/dashboard'
import DashboradToggle from './DashboradToggle'
import TableLoadingTemplate from '../loadingTemplate/tableLoadingTemplate/TableLoadingTemplate'

export default function WaitScrutinize({ config, onSettingChange = () => {} }) {
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  let history = useHistory()

  useEffect(() => {
    if (config) {
      setSchema(settingSchema)
    } else {
      handelGetSchemaDashboard(5, 1)
    }
  }, [])

  const handelGetSchemaDashboard = async (
    pagesize,
    pagenumber,
    projectCodeSearch,
    projectNameSearch
  ) => {
    setIsLoading(true)
    // startLoading()
    try {
      const response = await getScrutinize(
        pagesize,
        pagenumber,
        projectCodeSearch,
        projectNameSearch
      )
      // console.log('getScrutinize => ', JSON.stringify(response))
      setSchema(response)
    } catch (e) {
      setError({})
    }
    // doneLoading()
    setIsLoading(false)
  }

  const onSingleSubmit = (obj) => {
    sessionStorage.setItem('projectId', obj.id)
    sessionStorage.setItem('param', '')
    // console.log('id', obj.ig)
    history.push(`${pathname.proposal.overview.overviewCoworker}`)
  }
  // filter

  if (!schema) {
    return <TableLoadingTemplate />
  }

  return (
    <>
      {schema && (
        <>
          {config && (
            <DashboradToggle
              onChange={onSettingChange}
              dashboradName={config.key}
              checked={config.show}
              style={{ marginTop: 20, marginBottom: -15 }}
            />
          )}
          <ProjectDataTable
            schema={schema}
            subName={{ enable: true }}
            single={{
              enable: true,
              buttonText: schema?.buttonText,
            }}
            onSingleSubmit={onSingleSubmit}
            pagination={true}
            onReload={handelGetSchemaDashboard}
            loading={isLoading}
            searchEnable={true}
            setting={config && true}
          >
            <hr />
          </ProjectDataTable>
        </>
      )}
    </>
  )
}

const settingSchema = {
  header: 'โครงการที่รอกลั่นกรอง',
  projectCodeText: 'รหัสโครงการ',
  projectNameText: 'ชื่อโครงการ',
  projectTypeText: 'ประเภทโครงการ',
  projectBudgetText: 'งบประมาณรวม',
  buttonText: 'กลั่นกรอง',
  mutiButtonText: 'ไปยังการกลั่นกรอง',
  singleIcon: 'filter',
  totalSize: 1,
  values: [
    {
      id: 'XXX',
      projectCode: 'XX-XXXXX',
      projectName: {
        name: 'โครงการ XXX',
        statusName: 'XXX',
      },
      projectBudget: '0.00',
      projectType: {
        value: 'โครงการ',
        label: '1',
      },
    },
  ],
}
